import React from "react";
import "./SearchModal.css"; // 모달 전용 CSS (예: 오버레이, 모달 스타일)

const SearchModal = ({
  typedSearchTerm,
  setTypedSearchTerm,
  onSearch,
  onClose,
  onKeyDown
}) => {
  return (
    <div className="search-modal-overlay" onClick={onClose}>
      <div className="search-modal" onClick={(e) => e.stopPropagation()}>
        <input
          type="text"
          placeholder="🔍 상품 검색..."
          value={typedSearchTerm}
          onChange={(e) => setTypedSearchTerm(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Escape") onClose();
            else if (onKeyDown) onKeyDown(e);
          }}
          autoFocus
        />
      </div>
    </div>
  );
};

export default SearchModal;
